import * as Sentry from '@sentry/react-native';
import * as SplashScreen from 'expo-splash-screen';
import Constants from 'expo-constants';
import React, { FC, PropsWithChildren, useEffect } from 'react';
import { ApolloApp } from './Apolloapp';
import { IRootStore } from '../../state/stores/Root/RootStore';
import { LogBox } from 'react-native';
import { OneSignalProvider } from './OneSignalContext';
import { RootStoreProvider } from '../../hooks/useStores';
import { TokenInjector } from './TokenInjector';
import { amplitudeInit, logAmplitude } from '../../utils/analytics/analytics';
import { sentryInit } from '../../utils/sentry/sentry';
import { setupRootStore } from '../../state/stores/Root/setup-root-store';
import { useGlobalSearchParams, usePathname } from 'expo-router';
import { useIntelliProveListener } from '../../hooks/content/faceScan/useIntelliProveListener';
import { useOnMount } from '../../hooks/useOnMount';

SplashScreen.preventAutoHideAsync();

sentryInit();


const IntelliProveListenerSetup: FC = () => {
  useIntelliProveListener();
  return null;
};

export const AppSetupWithoutSentry : FC<PropsWithChildren>= ({children}) => {
  const [rootStore, setRootStore] = React.useState<IRootStore | undefined>(undefined);

  const pathname = usePathname();
  const params = useGlobalSearchParams();



  const setupEnvVariableExpo = () => {
    try {
      Object.entries(Constants.expoConfig?.extra?.env).forEach(([key, value]) => {
        if (!key.startsWith('EXPO_PUBLIC_') || process.env[key]) return;
        process.env[key] = `${value}`;
      });
    } catch (error) {
      console.log('Error setting up env variable', error);

    }
  };

  useEffect(() => {
    if(!pathname) return;
    const paramsPruned = params;
    if('screen' in params) { delete paramsPruned['screen']; }
    if('params' in params) { delete paramsPruned['params']; }
    logAmplitude(pathname.substring(1) + ' Navigated', paramsPruned);
  }, [pathname, params]);


  React.useEffect(() => {

    amplitudeInit();
    setupEnvVariableExpo();

    setupRootStore().then(setRootStore);

  }, []);

  useOnMount(() => {
    LogBox.ignoreLogs(['Provided value to SecureStore is larger than 2048 bytes. An attempt to store such a value will throw an error in SDK 35.']);
    // 'Require cycle' is deliberately NOT suppressed any more: the 83 cycles it was
    // hiding are fixed (route keys moved to constants/routeKeys.ts, a leaf module),
    // so any new one should be visible rather than silently ignored.
    LogBox.ignoreLogs(['StyleSheet.compose(a,']);
  });





  return (

    <RootStoreProvider value={rootStore}>
      <OneSignalProvider>

        <ApolloApp >
          <IntelliProveListenerSetup />
          <TokenInjector/>
          {children}
        </ApolloApp>
      </OneSignalProvider>

    </RootStoreProvider>
  );
};

export const AppSetup = Sentry.wrap(AppSetupWithoutSentry);
